import { Plugin } from 'ckeditor5';
import { OrcaPlaceholderSchema } from './OrcaPlaceholderSchema';
import { PlaceholderStore } from './store';
import { PlaceholderToolbar } from './toolbar';
import { PlaceholderWidget } from './widget';
import './style.css';
const PLACEHOLDER_CLASS = 'placeholders-enabled';
/**
 * This plugin adds support for rendering placeholders in the Orca editor.
 */
export class OrcaPlaceholders extends Plugin {
    static get pluginName() {
        return 'Placeholders';
    }
    static get requires() {
        return [PlaceholderStore, OrcaPlaceholderSchema, PlaceholderToolbar, PlaceholderWidget];
    }
    init() {
        const { editor } = this;
        editor.editing.view.change((writer) => {
            const viewEditableRoot = editor.editing.view.document.getRoot();
            if (viewEditableRoot) {
                writer.setAttribute('class', PLACEHOLDER_CLASS, viewEditableRoot);
            }
        });
    }
}
